import * as React from 'react';

import { IConditionalWrapperProps } from './types';

/**
 * The ConditionalWrapper allows you to wrap or not a component w/ another component based on a condition.
 */
const ConditionalWrapper = ({ condition, wrapper, children }: IConditionalWrapperProps) => (
  <>{condition ? wrapper(children) : children}</>
);
export default ConditionalWrapper;
